export default "__VITE_ASSET__CsuZEwZu__"